<template>
  <div class="card">
    <div class="section-spacing-20">
      <div
        class="card-header d-flex justify-content-between align-items-center"
        :class="{ 'pb-0': isCollapsible && !collapsed }"
      >
        <div class="header-content">
          <slot name="header" />
          <sera-button
            v-if="isCollapsible"
            :icon="`fa fa-solid fa-angle-${collapsed ? 'down' : 'up'}`"
            icon-position="right"
            class="collapse-button"
            @click="handleToggleCollapse"
          />
        </div>
      </div>
      <div v-if="isCollapsible && !collapsed" class="card-body">
        <slot name="body" />
      </div>
    </div>
  </div>
</template>

<script>
import SeraButton from "@/components/Button.vue";
export default {
  components: {
    SeraButton
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  computed: {
    isCollapsible() {
      return !!this.$slots.body;
    },
    collapsed: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      }
    }
  },
  methods: {
    handleToggleCollapse() {
      this.collapsed = !this.collapsed;
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.5rem;
  box-shadow: 0 3px 6px 0 var(--secondary-color);

  .card-header {
    border-radius: 25px 25px 0 0;
    padding: 0.75rem 0;
    margin: 0 1.25rem;

    .header-content {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      color: var(--text-color-ss);
      width: 100%;
      margin-right: 15px;

      .collapse-button {
        color: var(--primary-color);
        font-size: 1.6em;
      }
    }
  }

  .card-body {
    color: var(--text-color-ss);
    flex: 1 1 auto;
    padding: 0 1.25rem 1.25rem;
  }
}
</style>
